import React from 'react'

export default function AboutWeb() {
  return (
    <div>AboutWeb</div>
  )
}
